/* tslint:disable */
/* eslint-disable */
/**
 * Poolside API
 * Poolside API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiDocumentType {
    Document = 'DOCUMENT',
    Report = 'REPORT',
    Form = 'FORM',
    Other = 'OTHER'
}

export function ApiDocumentTypeFromJSON(json: any): ApiDocumentType {
    return ApiDocumentTypeFromJSONTyped(json, false);
}

export function ApiDocumentTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiDocumentType {
    return json as ApiDocumentType;
}

export function ApiDocumentTypeToJSON(value?: ApiDocumentType | null): any {
    return value as any;
}

